/**
 * Brilheza wishlist — localStorage-based, device/browser-scoped.
 *
 * This is NOT synced to the customer account or across devices/browsers: it
 * lives entirely in this browser's localStorage. If cross-device wishlist
 * sync is ever needed, that requires either a wishlist app from the Shopify
 * App Store, or a custom backend writing to customer metafields via the
 * Admin API. That's a scope boundary, not a bug — flag it rather than
 * "fixing" it locally.
 */
var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  drawerItems: '[data-wishlist-items]',
  drawerEmpty: '[data-wishlist-empty-state]',
};

document.addEventListener('DOMContentLoaded', function () {
  setupButtons(document.querySelectorAll(selectors.button));
  populateAllContainers();
});

function populateAllContainers() {
  var grid = document.querySelector(selectors.grid);
  if (grid) populateContainer(grid, null, 'card');

  var drawerItems = document.querySelector(selectors.drawerItems);
  var drawerEmpty = document.querySelector(selectors.drawerEmpty);
  if (drawerItems) populateContainer(drawerItems, drawerEmpty, 'drawer-card');
}

var setupGrid = function (grid) {
  populateContainer(grid, null, 'card');
};

var populateContainer = function (container, emptyStateEl, view) {
  view = view || 'card';
  var wishlist = getWishlist();
  var wishlistExistBtn = document.querySelector('.wishlist-page');
  if (wishlistExistBtn && wishlist.length > 0) {
    wishlistExistBtn.classList = 'wishlist_exists';
  }

  if (!wishlist.length) {
    container.innerHTML = '';
    container.style.display = 'none';
    if (emptyStateEl) emptyStateEl.style.display = 'block';
    return;
  }

  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=' + view;
    return fetch(productTileTemplateUrl).then(function (res) {
      if (!res.ok) return unavailableCardMarkup(handle);
      return res.text();
    }).catch(function () {
      return unavailableCardMarkup(handle);
    });
  });

  Promise.all(requests).then(function (responses) {
    container.innerHTML = responses.join('');
    container.style.display = 'block';
    if (emptyStateEl) emptyStateEl.style.display = 'none';
    setupButtons(container.querySelectorAll(selectors.button));
  });
};

var unavailableCardMarkup = function (handle) {
  return (
    '<div class="mini-cart-item clearfix wishlist-item-unavailable" data-product-handle="' + handle + '">' +
      '<div class="mini-cart-info">' +
        '<h6>No longer available</h6>' +
        '<button type="button" class="mini-cart-item-delete-inline" data-remove-unavailable data-product-handle="' + handle + '">' +
          'Remove' +
        '</button>' +
      '</div>' +
    '</div>'
  );
};

document.addEventListener('click', function (e) {
  var removeBtn = e.target.closest('[data-remove-unavailable]');
  if (!removeBtn) return;
  updateWishlist(removeBtn.dataset.productHandle);
  populateAllContainers();
});

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', function () {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      populateAllContainers();
    });
  });
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: array.length, handles: array } }));
  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

$(document).on('click', '.action-wishlist', function(){
  var $btn = $(this);
  $btn.addClass("loading-wishlist adding-wishlist");
  setTimeout(function () {
    $btn.removeClass("loading-wishlist");
  },1000);
  setTimeout(function () {
    $btn.removeClass("adding-wishlist");
  },2000);
});
